'use strict'

module.exports = {
  // https://github.com/libp2p/specs/tree/master/fetch#wire-protocol
  PROTOCOL: '/libp2p/fetch/0.0.1'
}
